<script setup lang="ts">
import { PV } from "@/widgets";
import Icon from "~icons/prime/times";

defineEmits<{
    click: [];
}>();
</script>

<template>
    <PV.Button v-tooltip.left="'Batal'" class="p-0!" link @click="$emit('click')">
        <Icon class="bg-gray-500 text-white rounded-sm p-0.5 hover:cursor-pointer" />
    </PV.Button>
</template>
